/**
 * 🍪 Biscuit Shop - Terminal Typing Animation
 * Cybersecurity-themed typing effect for headings and product titles
 */

// Multiple triggers to ensure script runs when content is ready
function initBiscuitTerminal() {
  console.log('🍪 Biscuit Shop Terminal Typing Script Starting...');
  // Terminal typing effect
  function initTerminalTyping() {
    console.log('🔧 Initializing terminal typing effect...');
    
    // Target selectors for typing effect - Updated with actual Shopify theme classes
    const selectors = [
      'h1', 'h2', 'h3',
      '.banner__heading',
      '.blog__title',
      '.page-title'
    ];
    
    const elements = document.querySelectorAll(selectors.join(', '));
    console.log(`🎯 Found ${elements.length} elements to animate:`, elements);
    
    elements.forEach((element, index) => {
      // Skip if element is empty or already processed
      if (!element.textContent.trim() || element.classList.contains('terminal-typed')) {
        console.log('⏭️ Skipping element:', element, 'Empty text:', !element.textContent.trim(), 'Already processed:', element.classList.contains('terminal-typed'));
        return;
      }
      
      // Skip if element is inside a card or product link (prevents click interference)
      if (element.closest('.card') || 
          element.closest('.product-card-wrapper') || 
          element.closest('[href]') ||
          element.closest('a') ||
          element.closest('.card-wrapper')) {
        console.log('🚫 Skipping element inside card/link:', element);
        return;
      }
      
              const originalText = element.textContent.trim();
        const typingSpeed = Math.random() * 50 + 30; // Random speed 30-80ms
        const startDelay = index * 200; // Stagger animations
        
        console.log(`✍️ Processing element ${index + 1}:`, element, 'Text:', originalText);
        
        // Mark as processed
        element.classList.add('terminal-typed');
      
      // PRESERVE SPACE: Measure element dimensions before clearing text
      const elementHeight = element.offsetHeight;
      const elementWidth = element.offsetWidth;
      const computedStyle = window.getComputedStyle(element);
      const lineHeight = computedStyle.lineHeight;
      
      // Set minimum dimensions to prevent layout shift
      element.style.minHeight = elementHeight + 'px';
      element.style.minWidth = elementWidth + 'px';
      element.style.boxSizing = 'border-box';
      
              // Add terminal styling
        element.style.position = 'relative';
        element.style.fontFamily = '"Courier New", monospace';
        
        // Ensure our changes don't interfere with click events
        element.style.pointerEvents = 'auto';
        element.style.zIndex = 'auto';
        
        // Clear original text AFTER preserving dimensions
        element.textContent = '';
      
      // Create cursor
      const cursor = document.createElement('span');
      cursor.className = 'terminal-cursor';
      cursor.textContent = '█';
      cursor.style.cssText = `
        color: var(--biscuit-accent, #6eacda);
        animation: terminal-blink 1s infinite;
        text-shadow: 0 0 10px var(--biscuit-accent, #6eacda);
        font-weight: normal;
      `;
      
      // Start typing after delay
      setTimeout(() => {
        let currentIndex = 0;
        
        function typeNextChar() {
          if (currentIndex < originalText.length) {
            element.textContent = originalText.substring(0, currentIndex + 1);
            element.appendChild(cursor);
            currentIndex++;
            setTimeout(typeNextChar, typingSpeed);
          } else {
            // Remove cursor after typing is complete and reset min-width
            setTimeout(() => {
              if (cursor.parentNode) {
                cursor.remove();
              }
              // Remove minimum width constraint after typing is complete
              element.style.minWidth = '';
            }, 2000);
          }
        }
        
        typeNextChar();
      }, startDelay);
    });
  }
  
  // Add CSS for blinking cursor animation
  const terminalStyle = document.createElement('style');
  terminalStyle.textContent = `
    @keyframes terminal-blink {
      0%, 50% {
        opacity: 1;
      }
      51%, 100% {
        opacity: 0;
      }
    }
    
    .terminal-typed {
      overflow: hidden;
      transition: min-height 0.3s ease, min-width 0.3s ease;
    }
    
    .terminal-cursor {
      display: inline-block;
      margin-left: 2px;
    }
    
    /* Enhanced glow for typed text */
    .terminal-typed {
      text-shadow: 0 0 20px var(--biscuit-glow, rgba(110, 172, 218, 0.3));
      transition: text-shadow 0.3s ease, min-height 0.3s ease, min-width 0.3s ease;
    }
    
    .terminal-typed:hover {
      text-shadow: 0 0 30px var(--biscuit-glow, rgba(110, 172, 218, 0.5));
    }
    
    /* Prevent cumulative layout shift during typing */
    .terminal-typed {
      will-change: contents;
    }
  `;
  document.head.appendChild(terminalStyle);
  
  // Initialize typing effect
  initTerminalTyping();
  
  // Re-run on dynamic content (for AJAX loaded content)
  const observer = new MutationObserver(function(mutations) {
    let shouldRetype = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            shouldRetype = true;
          }
        });
      }
    });
    
    if (shouldRetype) {
      setTimeout(initTerminalTyping, 500);
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Add special terminal prompt for product descriptions (avoid cards)
  const productDescriptions = document.querySelectorAll('.product__description:not(.card *), .card__text:not(.card *)');
  productDescriptions.forEach((desc, index) => {
    // Skip if inside a card or clickable element
    if (desc.closest('.card') || desc.closest('a') || desc.closest('[href]')) {
      return;
    }
    
    if (desc.textContent.trim() && !desc.classList.contains('terminal-prompt-added')) {
      desc.classList.add('terminal-prompt-added');
      
      const prompt = document.createElement('span');
      prompt.style.cssText = `
        color: var(--biscuit-accent);
        font-family: 'Courier New', monospace;
        font-weight: bold;
        text-shadow: 0 0 10px var(--biscuit-accent);
        margin-right: 8px;
        pointer-events: none;
      `;
      prompt.textContent = '$ ';
      
      // Add prompt to beginning of description
      desc.style.fontFamily = '"Courier New", monospace';
      desc.insertBefore(prompt, desc.firstChild);
    }
  });
  
  // Add terminal effect to buttons on hover (desktop only, avoid mobile interference)
  const buttons = document.querySelectorAll('.btn, .button, [role="button"]');
  buttons.forEach(button => {
    // Only add hover effects on non-touch devices to avoid mobile click issues
    if (!('ontouchstart' in window)) {
      button.addEventListener('mouseenter', function() {
        const originalText = this.textContent;
        if (!originalText.startsWith('> ') && !this.closest('.card')) {
          this.textContent = '> ' + originalText;
          this.style.fontFamily = '"Courier New", monospace';
        }
      });
      
      button.addEventListener('mouseleave', function() {
        const text = this.textContent;
        if (text.startsWith('> ')) {
          this.textContent = text.substring(2);
          this.style.fontFamily = '';
        }
      });
    }
  });
}

// Initialize on multiple events to ensure it runs
document.addEventListener('DOMContentLoaded', initBiscuitTerminal);
window.addEventListener('load', initBiscuitTerminal);

// Also try after a short delay for dynamic content
setTimeout(initBiscuitTerminal, 1000);
setTimeout(initBiscuitTerminal, 3000); 